module.exports = __webpack_public_path__ + "assets/ca5fd70a1978781b1525488863173b2d.png";